export default __webpack_public_path__ + "static/media/property_914.a487224f.png";